export default __webpack_public_path__ + "static/media/TBM-4.9a071034.jpg";